export function normalizeEventId(value) {
   if (value == null) return "";
   return String(value).trim();
}

export function readEventId(row) {
   if (!row || typeof row !== "object") return "";
   return normalizeEventId(
      row.id ??
         row._id ??
         row.reservationId ??
         row.reservation_id ??
         row.reservation?.id ??
         row.reservation?._id,
   );
}

export function makeSlotKey(dayIndex, instructorId, slotLabel) {
   const day = Number(dayIndex);
   const inst = String(instructorId ?? "").trim();
   const slot = String(slotLabel ?? "").trim();
   if (!Number.isFinite(day) || day < 0 || !inst || !slot) return "";
   return `${day}|${inst}|${slot}`;
}

export function parseSlotKey(slotKey) {
   const raw = String(slotKey || "").trim();
   if (!raw) return null;
   const parts = raw.split("|");
   if (parts.length < 3) return null;
   const dayIndex = Number(parts[0]);
   const instructorId = String(parts[1] || "").trim();
   const slotLabel = parts.slice(2).join("|").trim();
   if (!Number.isFinite(dayIndex) || dayIndex < 0 || !instructorId || !slotLabel) {
      return null;
   }
   return { dayIndex, instructorId, slotLabel };
}
